module.exports = __webpack_public_path__ + "img/appIcon-menu--Applications--active.102f0887.svg";